/*
 * Same-tab change notification for localStorage keys: the native `storage` event only reaches other tabs. Shared by the
 * main search's recent filters and the prices search's recent store, so each hears the other's writes.
 */

export const RECENT_SEARCHES_CHANGED_EVENT = "pg:recent-searches-changed";

export interface IStorageChangeEventDetail {
    key: string;
}

/** Tells same-tab subscribers of `key` that its value changed (the native `storage` event only reaches other tabs). */
export const dispatchStorageChange = (key: string): void => {
    if (typeof window === "undefined") {
        return;
    }

    window.dispatchEvent(new CustomEvent<IStorageChangeEventDetail>(RECENT_SEARCHES_CHANGED_EVENT, {detail: {key}}));
};

/** Calls `listener` when any of `keys` changes, in this tab or another one. `storage.clear()` elsewhere counts too. */
export const subscribeToStorageKeys = (keys: readonly string[], listener: () => void): (() => void) => {
    if (typeof window === "undefined") {
        return () => undefined;
    }

    const onStorage = (event: StorageEvent) => {
        if (event.key === null || keys.includes(event.key)) {
            listener();
        }
    };
    const onChange = (event: Event) => {
        const detail = (event as CustomEvent<IStorageChangeEventDetail | undefined>).detail;

        if (detail && keys.includes(detail.key)) {
            listener();
        }
    };

    window.addEventListener("storage", onStorage);
    window.addEventListener(RECENT_SEARCHES_CHANGED_EVENT, onChange);

    return () => {
        window.removeEventListener("storage", onStorage);
        window.removeEventListener(RECENT_SEARCHES_CHANGED_EVENT, onChange);
    };
};
/*
 * Same-tab change notification for localStorage keys: the native `storage` event only reaches other tabs. Shared by the
 * main search's recent filters and the prices search's recent store, so each hears the other's writes.
 */

export const RECENT_SEARCHES_CHANGED_EVENT = "pg:recent-searches-changed";

export interface IStorageChangeEventDetail {
    key: string;
}

/** Tells same-tab subscribers of `key` that its value changed (the native `storage` event only reaches other tabs). */
export const dispatchStorageChange = (key: string): void => {
    if (typeof window === "undefined") {
        return;
    }

    window.dispatchEvent(new CustomEvent<IStorageChangeEventDetail>(RECENT_SEARCHES_CHANGED_EVENT, {detail: {key}}));
};

/** Calls `listener` when any of `keys` changes, in this tab or another one. `storage.clear()` elsewhere counts too. */
export const subscribeToStorageKeys = (keys: readonly string[], listener: () => void): (() => void) => {
    if (typeof window === "undefined") {
        return () => undefined;
    }

    const onStorage = (event: StorageEvent) => {
        if (event.key === null || keys.includes(event.key)) {
            listener();
        }
    };
    const onChange = (event: Event) => {
        const detail = (event as CustomEvent<IStorageChangeEventDetail | undefined>).detail;

        if (detail && keys.includes(detail.key)) {
            listener();
        }
    };

    window.addEventListener("storage", onStorage);
    window.addEventListener(RECENT_SEARCHES_CHANGED_EVENT, onChange);

    return () => {
        window.removeEventListener("storage", onStorage);
        window.removeEventListener(RECENT_SEARCHES_CHANGED_EVENT, onChange);
    };
};
